module.exports = __webpack_public_path__ + "img/galaxy-smart-tag-2-pack-copy@2x.db6b9807.png";